import { loadProjectInfo, consumerProjectInfoReducer } from './consumerInfoStore';
import {
    consumerSupportReducer,
    cSupportActions
} from './consumerSupportStore';
import { loadUser, loadRoles, consumerUsersReducer } from './consumerUserStore';
import { ConsumerStore } from '@interfaces/consumer/store';

import { combineReducers } from '@reduxjs/toolkit';
import { cPaymentsReducer } from './consumerPaymentsStore';

export const consumerReducer = combineReducers({
    support: consumerSupportReducer,
    users: consumerUsersReducer,
    projectInfo: consumerProjectInfoReducer,
    payments: cPaymentsReducer
});

export const consumerActions = {
    loadRoles,
    loadUser,
    loadProjectInfo,

    support: cSupportActions
}